export default "__VITE_ASSET__dGzFK0bM__"